import axios from './axios'

const getBonuses = () => axios.get('/admin/bonuses')

const BonusesServices = {
  getBonuses
}

export default BonusesServices